module.exports = __webpack_public_path__ + "img/air.95eed13e.png";